export const REF_MATERIALS_PATH_PREFIX = 'reference-materials';
